import { h } from '../components/dom';

export interface CurtainHandles {
  finish: Promise<void>;
}

/**
 * Renders the page-load counter curtain. Returns a promise that resolves once
 * the curtain has lifted, so the caller can begin the hero reveal in sync.
 */
export function showCurtain(durationMs = 1100): CurtainHandles {
  const num = h('span', { class: 'n' }, '00');
  const bar = h('div', { class: 'fx-curtain__bar' });
  const count = h('div', { class: 'fx-curtain__count' });
  count.append(num, h('em', {}, '%'));

  const curtain = h('div', { class: 'fx-curtain' }, count, bar);
  document.body.appendChild(curtain);

  const start = performance.now();

  return {
    finish: new Promise<void>((resolve) => {
      const tick = () => {
        const t = Math.min(1, (performance.now() - start) / durationMs);
        const eased = 1 - Math.pow(1 - t, 3);
        const pct = Math.round(eased * 100);
        num.textContent = String(pct).padStart(2, '0');
        bar.style.width = pct + '%';
        if (t < 1) requestAnimationFrame(tick);
        else {
          setTimeout(() => {
            curtain.classList.add('out');
            setTimeout(() => {
              curtain.remove();
              resolve();
            }, 1000);
          }, 200);
        }
      };
      requestAnimationFrame(tick);
    }),
  };
}
